<template>
    <div class="grid xl:grid-cols-2 grid-cols-1">
        <div class="flex items-center justify-center md:mb-0 mb-3">
            <div>
                <h1 class="font-bold text-xl text-gray-200 mb-2">{{__("Want to keep up with the news?")}}</h1>
                <h3 class="font-bold text-md text-gray-500">{{__("Subscribe to our newsletter and let's stay in touch")}}</h3>
            </div>
        </div>
        <div class="flex items-center justify-center lg:mx-auto">
            <div class="flex flex-col mt-2">
            <div class="space-y-2">
                <div class="flex">
                    <InputLabel
                        class="flex-1"
                        :placeholder="__('Email')"
                        inputClass="h-full rounded-r-0"
                        rounded="rounded-l-md"
                        autocomplete="email"
                        type="email"
                        @keyup.enter="subscribe()"
                        v-model="subscribe_form.email"
                    />
                    <Button
                        padding="xl"
                        color="red"
                        type="button"
                        rounded="rounded-r-md"
                        @click="subscribe()"
                    >{{__('Sign up')}}</Button>
                </div>
                <Recaptcha
                    class="mx-auto"
                    v-model="subscribe_form.recaptcha_token"
                />
            </div>
            <p class="text-gray-400 text-xs mt-1">
                {{__('We care about the protection of your data.')}}
                <InertiaLink
                    :href="route('page.show', 'privacy-policy')"
                    class="no-underline hover:underline"
                >
                    {{__('Read our Privacy Policy')}}
                </InertiaLink>
            </p>
            </div>
        </div>
    </div>
</template>
<script>
import InputLabel from 'UI/InputLabel';
import Button from 'UI/Button';
import { useForm, usePage } from '@inertiajs/inertia-vue3'
import Recaptcha from 'UI/Recaptcha'

export default {
    components: { InputLabel, Button, Recaptcha },
    setup() {
        const subscribe_form = useForm({
            email: null,
            locale: usePage().props.value.locale,
            recaptcha_token: null
        })
        const subscribe = () => {
            subscribe_form.post( route('subscribe'), {
                preserveScroll: true,
            });
        }

        return {
            subscribe,
            subscribe_form,
        }
    }
}
</script>
